import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: "Home",
  class: "flex flex-col min-h-screen h-full w-full justify-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")
  const _component_banner = _resolveComponent("banner")
  const _component_share_info = _resolveComponent("share-info")
  const _component_challenges = _resolveComponent("challenges")
  const _component_home_footer = _resolveComponent("home-footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_logo, { class: "hidden sm:block mt-10 px-10" }),
    _createVNode(_component_banner),
    _createVNode(_component_share_info),
    _createVNode(_component_challenges),
    _createVNode(_component_home_footer)
  ]))
}